export const isUserLoggedIn = () => {
    const token = sessionStorage.getItem("token");
    if (token) {
        if (token) {
            return true;
        } else {
            return false;
        }
    }
};